import { userActionTypes } from '../actionTypes';
import { authStates } from '../authStates';

export const userInitialState = {
    currentState: authStates.UNKNOWN,
    firebaseUser: {},
    zaplifyUser: {},
    isLoadingData: false,
    authErrorMessage: null,
    typeOfError: null,
    preventRedirectToLogin: false,
};

const userReducer = (state = userInitialState, action) => {
    switch (action.type) {
        case userActionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                firebaseUser: action.firebaseUser.uid,
                authErrorMessage: null,
                typeOfError: null,
            };
        case userActionTypes.START_LOADING:
            return {
                ...state,
                isLoadingData: true,
            };
        case userActionTypes.STOP_LOADING:
            return {
                ...state,
                isLoadingData: false,
            };
        case userActionTypes.LOGIN_FAILED:
            return {
                ...state,
                firebaseUser: {},
                authErrorMessage: action.authErrorMessage,
            };
        case userActionTypes.FETCH_USER_SUCCESS:
            return {
                ...state,
                zaplifyUser: action.zaplifyUser,
                authErrorMessage: null,
            };
        case userActionTypes.FETCH_USER_FAILED:
            return {
                ...state,
                zaplifyUser: {},
                authErrorMessage: action.authErrorMessage,
            };
        case userActionTypes.LOGOUT_SUCCESS:
            return {
                ...state,
                zaplifyUser: {},
                firebaseUser: {},
                currentState: authStates.LOGGED_OUT,
                authErrorMessage: null,
            };
        case userActionTypes.PREVENT_REDIRECT_TO_LOGIN:
            return {
                ...state,
                preventRedirectToLogin: action.preventRedirectToLogin,
            };
        case userActionTypes.LOGOUT_FAILED:
            return {
                ...state,
                zaplifyUser: {},
                firebaseUser: {},
                currentState: authStates.LOGGED_OUT,
                authErrorMessage: action.authErrorMessage,
            };
        case userActionTypes.REGISTER_SUCCESS:
            return {
                ...state,
                firebaseUser: action.firebaseUser.uid,
                authErrorMessage: null,
                typeOfError: null,
            };
        case userActionTypes.REGISTER_FAILED:
            return {
                ...state,
                firebaseUser: {},
                authErrorMessage: action.authErrorMessage,
                typeOfError: action.typeOfError,
            };
        case userActionTypes.AUTH_STATE:
            return {
                ...state,
                currentState: action.authState,
            };
        case userActionTypes.CLEAN_AUTH_ERROR:
            return {
                ...state,
                authErrorMessage: null,
                typeOfError: null,
            };
        default:
            return state;
    }
};

export default userReducer;
